(function() {
  function addComingSoonClass() {
    const links = document.querySelectorAll('a.menu__item, a[is="magnet-link"], .header-drawer a, .menu-drawer a, .drawer a, nav a, .mobile-nav a, .header__drawer a');

    links.forEach(function(link) {
      const textEl = link.querySelector('[data-text]') || link;
      const text = (textEl.textContent || '').trim();

      if (text === 'Coming Soon') {
        link.classList.add('menu__item--coming-soon');
      }
    });
  }

  addComingSoonClass();
  setTimeout(addComingSoonClass, 500);
  setTimeout(addComingSoonClass, 1500);
  setTimeout(addComingSoonClass, 3000);
})();